import { vehicle_by_id } from '@helpers/constants.tsx';
import { Route, Simulation } from '@helpers/types.ts';
import { CallSplit, Delete } from '@mui/icons-material';
import {
  Checkbox,
  Chip,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import { formatNumber } from 'accounting';
import { FC } from 'react';

interface IRouteCardProps {
  route: Route;
  plan: Simulation | undefined;
  selected: boolean;
  onToggleSelection: (route: string) => void;
  onSplit: (route: Route) => void;
  onStartDisableRoute: (route: string) => void;
  focusRoute: (route: Array<string>) => void;
}

export const RouteCard: FC<IRouteCardProps> = (props) => {
  const ordersColor = props.route.orders.length >= 60 ? '#4CAF50' : '#EF5350';
  const capacityColor =
    props.route.capacity >= 90
      ? 'success'
      : props.route.capacity >= 70
        ? 'warning'
        : 'error';

  return (
    <Paper
      variant="outlined"
      className="p-4 relative hover:shadow-md transition-shadow cursor-pointer"
      sx={{ borderLeft: `4px solid ${props.route.color}` }}
      onClick={() => props.focusRoute([props.route.name])}
    >
      <div className="flex justify-between items-start mb-2">
        <div className="flex-1">
          <Typography variant="caption" color="text.secondary">
            Ruta
          </Typography>
          <Typography variant="subtitle1" fontWeight="bold">
            {props.route.name}
          </Typography>
        </div>
        <div className="flex items-center gap-1">
          {vehicle_by_id[Number(props.route.vehicle_type)]?.icon}
          <Typography variant="body2" fontWeight="medium">
            {vehicle_by_id[Number(props.route.vehicle_type)]?.label ??
              props.route.vehicle_type}
          </Typography>
        </div>
      </div>

      {props.route.container_name && (
        <div className="mb-3">
          <Typography variant="caption" color="text.secondary">
            Contenedor
          </Typography>
          <div className="flex flex-wrap gap-1 mt-1">
            <Chip
              size="small"
              variant="outlined"
              label={props.route.container_name}
            />
          </div>
        </div>
      )}

      <div className="flex items-center gap-4 pt-2 border-t border-gray-200">
        <Typography variant="body2">
          Total: <strong>{props.route.orders.length}</strong>
        </Typography>
        <Typography variant="body2">
          SPR:{' '}
          <strong style={{ color: ordersColor }}>
            {props.route.orders.length}
          </strong>
        </Typography>
        <Typography variant="body2">
          {formatNumber(props.route.time / 60 / 60, 1)}hrs /{' '}
          {formatNumber(props.route.distance / 1000)}km
        </Typography>
        <Chip
          size="small"
          color={capacityColor}
          label={`${formatNumber(props.route.capacity, 0)}%`}
        />
      </div>

      {props.route.disabled && (
        <Chip
          size="small"
          label="Desactivada"
          color="secondary"
          className="absolute top-2 right-16"
        />
      )}

      <div className="flex items-center justify-end mt-2 pt-2 border-t border-gray-100">
        {props.plan?.induct_accept === 'pending' && (
          <Tooltip title="Dividir ruta" placement="top">
            <span>
              <IconButton
                size="small"
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  props.onSplit(props.route);
                }}
                disabled={props.route.disabled}
              >
                <CallSplit fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        )}

        {props.plan?.induct_accept === 'pending' && (
          <Tooltip title="Desactivar ruta" placement="top">
            <span>
              <IconButton
                size="small"
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  props.onStartDisableRoute(props.route.id);
                }}
                disabled={props.route.disabled}
              >
                <Delete fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        )}

        <Checkbox
          size="small"
          checked={props.selected}
          onClick={(e) => {
            e.stopPropagation();
            props.onToggleSelection(props.route.id);
          }}
        />
      </div>
    </Paper>
  );
};
